module.exports = __webpack_public_path__ + "static/media/freubel-gonda-min.89d55e90.png";